/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalFooter,
  Button,
  Icon,
  Row,
  Col,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { useReactToPrint } from 'react-to-print';
// import { MarcRecord } from '@natlibfi/marc-record';
import SourceView from './SourceView';
import './PrintStyles.css';

function ViewSourceModal({ onClose, open, itemToView, selectedItems }) {
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="copycat-results-preview-print-record-source-btn"
          buttonStyle="primary"
          onClick={handlePrint}
        >
          <Icon icon="print">
            <FormattedMessage
              id="ui-inventory.copycat.buttons.print"
              defaultMessage="Print"
            />
          </Icon>
        </Button>
        <Button
          id="copycat-results-preview-view-source-modal-close-btn"
          buttonStyle="slim"
          onClick={onClose}
        >
          <Icon icon="times-circle-solid" size="large">
            <FormattedMessage id="stripes-core.button.close" />
          </Icon>
        </Button>
      </ModalFooter>
    );
  };

  const renderViewSelecteditems = () => {
    return (
      <Row>
        <Col xs={6}>
          <SourceView itemToView={selectedItems[0]} />
        </Col>
        <Col xs={6}>
          <SourceView itemToView={selectedItems[1]} />
        </Col>
      </Row>
    );
  };

  return (
    <Modal
      id="copycat-results-preview-view-source-modal"
      footer={renderFooter()}
      open={open}
      onClose={onClose}
      dismissible
      label={
        <Icon icon="info" size="large">
          {selectedItems.length ? (
            <FormattedMessage
              id="ui-inventory.copycat.resultsPreview.viewSourceModal.compare.label"
              defaultMessage="Compare source of two records"
            />
          ) : (
            <FormattedMessage
              id="ui-inventory.copycat.resultsPreview.viewSourceModal.view.label"
              defaultMessage="View record source"
            />
          )}
        </Icon>
      }
      size="large"
    >
      <div ref={printRef} className="print-content">
        {selectedItems.length ? (
          <>
            <div className="print-header">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>
                  <FormattedMessage
                    id="ui-plugin-copycat.copycat.print.source.label"
                    defaultMessage="Source"
                  />
                  :{' '}
                  <FormattedMessage
                    id={`ui-inventory.targetProfiles.name.${selectedItems[0]?.serverName}`}
                    defaultMessage={selectedItems[0]?.serverName}
                  />
                </strong>
                <strong>
                  <FormattedMessage
                    id="ui-plugin-copycat.copycat.print.source.label"
                    defaultMessage="Source"
                  />
                  :{' '}
                  <FormattedMessage
                    id={`ui-inventory.targetProfiles.name.${selectedItems[1]?.serverName}`}
                    defaultMessage={selectedItems[1]?.serverName}
                  />
                </strong>
              </div>
              <hr />
            </div>
            {renderViewSelecteditems()}
          </>
        ) : (
          <>
            <div className="print-header">
              <strong>
                <FormattedMessage
                  id="ui-plugin-copycat.copycat.print.source.label"
                  defaultMessage="Source"
                />
                :{' '}
                <FormattedMessage
                  id={`ui-inventory.targetProfiles.name.${itemToView?.serverName}`}
                  defaultMessage={itemToView?.serverName}
                />
              </strong>
              <hr />
            </div>
            <SourceView itemToView={itemToView} />
          </>
        )}
      </div>
    </Modal>
  );
}

ViewSourceModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  itemToView: PropTypes.object,
  selectedItems: PropTypes.arrayOf(PropTypes.object),
};

export default ViewSourceModal;
